// extracted by mini-css-extract-plugin
export var input = "v_3";
export var input__standalone = "v_bL";
export var label = "v_bM";
export var labelText = "v_bN";